import { getGroup, standards } from '@g17eco/core';
import type UniversalTrackerClassInterface from '../model/UniversalTrackerClassInterface';

/** The newest version of the metric's standard that the metric has, else its own type. */
const getLatestAlternativeCode = (utr: UniversalTrackerClassInterface) => {
  let currentStandard = getGroup('standards', utr.getType());
  const versionGroupCode = currentStandard?.versionGroupCode;
  if (!currentStandard || !versionGroupCode) {
    return utr.getType();
  }

  for (const standard of Object.values(standards)) {
    if (
      standard.versionGroupCode === versionGroupCode &&
      Number(standard.version) > Number(currentStandard.version) &&
      utr.hasAlternativeInfo(standard.code)
    ) {
      currentStandard = standard;
    }
  }

  return currentStandard.code;
};

/** The standard to show a metric in: the group's preferred one, the list's own, else its newest version. */
export const getAltCode = (
  utr: UniversalTrackerClassInterface,
  groupCode: string | undefined,
  preferredAltCodes: string[] | undefined,
): string => {
  const preferred = preferredAltCodes?.find((code) => utr.hasAlternativeInfo(code));
  if (preferred) {
    return preferred;
  }
  return groupCode && utr.hasAlternativeInfo(groupCode) ? groupCode : getLatestAlternativeCode(utr);
};
